import React from "react";
import { AiFillInstagram,  AiFillMail } from "react-icons/ai";

const Footer = () => {
  return (
    <footer>
      <div>
        <h2>Accedemic Asset's</h2>

        <p>We are trying to give students as much help as we can.</p>
        <br />

        <em>We give attention to genuine feedback.</em>

        <strong>All right received @accedemicassets</strong>
      </div>

      <aside>
        <h4>Follow Us</h4>

        <a href="https://instagram.com/siddhant_ramteke">
          <AiFillInstagram />
        </a>
        <a href="mailto:siddhantramteke5@gmail.com">
          <AiFillMail />
        </a>
        
      </aside>
    </footer>
  );
};

export default Footer;
